import * as XLSX from "xlsx"
import { isNotEmpty } from "./validation"

// Check that the file really is th extension it pretends to be, and
// is not a js file or an exe renamed.
export const checkFileIntegrity = async (file: File) => {
	return new Promise(async (resolve) => {
		if (!file.type) return resolve(false)

		const reader = new FileReader()
		reader.addEventListener("loadend", (event) => {
			const subarrayToCheck = new Uint8Array(event.target.result as ArrayBuffer).subarray(0, 4)
			const header = subarrayToCheck.reduce((acc, curr) => `${acc}${curr.toString(16)}`, "")
			const calculatedType = (() => {
				switch (header) {
					case "89504e47":
						return "image/png"
					case "47494638":
						return "image/gif"
					case "ffd8ffe0":
					case "ffd8ffe1":
					case "ffd8ffe2":
					case "ffd8ffe3":
					case "ffd8ffe8":
						return "image/jpeg"
					case "25504446":
						return "application/pdf"
					default:
						return "unknown"
				}
			})()

			if (calculatedType === file.type) resolve(true)
			else resolve(false)
		})
		reader.readAsArrayBuffer(file)
	})
}

export const exportXlsx = (columns, data, name = "") => {
    // prepare data
    const tabToExport = []
    // Header array
    tabToExport.push(Object.values(columns))
    // Data arrays
    data.forEach(item => {
        const rowToPush = []
        Object.keys(columns).forEach(columnKey => {
            rowToPush.push(item[columnKey])
        })
        tabToExport.push(rowToPush)
    })
    // prepare xlsx
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(tabToExport)

    // export sheet then file
    XLSX.utils.book_append_sheet(wb, ws, "OCODE")
    XLSX.writeFile(wb, `${name}.xlsx`)
}

export const importXlsx = (file) => {

    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsArrayBuffer(file)

        const options = {
            defval: null, // Use specified value in place of undefined
            range: 4, // remove 3 first line (header)
            header: [ // custom header
                "bike_id",
                "gear_type",
                "brand",
                "model",
                "color",
                "is_electric",
                "frame_serial_number",
                "engine_serial_number",
                "battery_serial_number",
                "last_name",
                "first_name",
                "private_owner_phone",
                "private_owner_mail",
                "social_reason",
                "company_owner_phone",
                "company_owner_mail",
                "bike_oconsumer_id"
            ],
        }

        fileReader.onload = (e) => {
            const bufferArray = e.target.result
            const wb = XLSX.read(bufferArray, { type: "buffer" })
            const wsName = wb.SheetNames[0]
            const ws = wb.Sheets[wsName]
            const bikes = XLSX.utils.sheet_to_json(ws, options)
            resolve(bikes)
        }
        fileReader.onerror = (error) => {
            reject(error)
        }
    })
}

export const convertDataToStringFromArray = (array) => {
    if(!isNotEmpty(array) || array.length === 0) return array
    return array.map(item => isNotEmpty(item) ? item.toString() : "")
}
